import * as yup from 'yup';
import { memoize } from 'lodash';

import TranslationHelper from '../helpers/TranslationHelper';
import {
    NAME_STRING_MAX_LENGTH,
    FIELD_REQUIRED,
    VALUE_TOO_LONG,
} from '../constants/yup';

export const gridViewSchema = memoize(() =>
    yup.object().shape({
        name: yup
            .string()
            .trim()
            .required(TranslationHelper.translate(FIELD_REQUIRED))
            .max(
                NAME_STRING_MAX_LENGTH,
                TranslationHelper.translate(VALUE_TOO_LONG)
            ),
        description: yup
            .string()
            .trim()
            .max(512, TranslationHelper.translate(VALUE_TOO_LONG)),
        groups: yup
            .mixed()
            .when('visibilityType', (visibilityType: string): any => {
                if (visibilityType === 'group') {
                    return yup
                        .array()
                        .min(
                            1,
                            TranslationHelper.translate(
                                'At least 1 group required'
                            )
                        );
                } else {
                    return;
                }
            }),
    })
);
